var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{class:_vm.classes}),_vm._v(" "+_vm._s(_vm.$t("enum.blocked[" + _vm.blocked + "]"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }